import useScope from '~/hooks/useScope'

import { ItemType } from '~/services/resolvers/types'

import * as Styled from './style'
import type * as Types from './types'

const NoResults: Types.NoResultsComponent = (props) => {
    const {
        width,
        type,
        heigth
    } = props

    const { id: scopeId } = useScope()

    const getUrl = () => {
        switch (type) {
            case ItemType.MemorialAd:
                return `https://www.${scopeId}.se/privatannons`

            case ItemType.BirthdayAd:
                return `https://www.${scopeId}.se/privatannons`

            case ItemType.Job:
                return `https://medieportalen.${scopeId}.se/rekrytering/`

            case ItemType.Company:
                return `https://medieportalen.${scopeId}.se/`

            default:
                return `https://foretag-gota.cargoselfservice.com/`
        }
    }

    return (
        <Styled.Container
            style={{
                width: width,
                height: heigth
            }}
        >
            <Styled.Headline>
                {'Inga annonser att visa.'}
            </Styled.Headline>
            <Styled.SubHeadline>
                {'Vill du att din annons ska synas här?'}

                <Styled.Anchor
                    href={getUrl()}
                    target={'_blank'}
                >
                    {'Boka annons'}
                </Styled.Anchor>
            </Styled.SubHeadline>
        </Styled.Container>
    )
}

export default NoResults